
import { Vue } from "vue-class-component";

export default class PlusCircleOutline extends Vue {}
